import React from "react";
import Modal from "../Modal";
import ReservationForm from "./ReservationForm";

export default function ReservationModal({ open, closeModal, apartment }) {
  if (open) {
    return (
      <Modal closeModal={closeModal}>
        <ReservationForm apartment={apartment} />
      </Modal>
    );
  }
  return "";
}
